import React, { useContext } from 'react';
import { TagsContext } from '../contexts/TagsContext';
import SnackbarContext from '../contexts/SnackbarContext';
import { tagsPathTo } from '../utils/Api';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';

const filter = createFilterOptions();

const TagsEdit = (props) => {
  const { tags, addTag } = useContext(TagsContext);
  const { openSnackbar } = useContext(SnackbarContext);
  const [open, toggleOpen] = React.useState(false);
  const [dialogValue, setDialogValue] = React.useState({
    name: '',
  });

  const handleClose = () => {
    setDialogValue({
      name: '',
    });
    toggleOpen(false);
  };

  const handleDialogSubmit = (event) => {
    event.preventDefault();
    event.stopPropagation();
    tagsPathTo.save({
      name: dialogValue.name,
    }).then((result) => {
      openSnackbar("Tag adicionada com sucesso!", "success");
      addTag(result.data);
      props.setResource((prevState) => ({
        ...prevState,
        tags: [...(prevState.tags || []), result.data], // Ensure tags is always an array
      }));
    });

    handleClose();
  };

  // Ensure the value prop is always an array (controlled mode)
  const autocompleteValue = props.resource.tags || [];

  return (
    <div>
      <Autocomplete
        multiple
        options={tags}
        getOptionLabel={(option) => option.name}
        onChange={(event, newValue) => {
          const newTag = newValue.find((tag) => tag.inputValue !== undefined);

          if (newTag) {
            setTimeout(() => {
              toggleOpen(true);
              setDialogValue({ name: newTag.inputValue });
            });
          } else {
            props.setResource((prevState) => ({
              ...prevState,
              tags: newValue, // newValue is already an array
            }));
          }
        }}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        value={autocompleteValue} // Use controlled value with fallback
        filterSelectedOptions
        filterOptions={(options, params) => {
          const filtered = filter(options, params);

          if (filtered.length === 0 && params.inputValue !== '') {
            filtered.push({
              inputValue: params.inputValue,
              name: `Adicionar "${params.inputValue}"`,
            });
          }
          return filtered;
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Tags"
            placeholder=""
            onKeyDown={(event) => {
              if (event.key === 'Enter') {
                event.preventDefault();
              }
            }}
          />
        )}
      />

      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Adicionar nova tag</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            value={dialogValue.name}
            onChange={(event) =>
              setDialogValue({
                name: event.target.value,
              })
            }
            label="Nome"
            type="text"
            variant="standard"
          />
        </DialogContent>
        <DialogActions>
          <Button type="button" onClick={handleClose}>Cancelar</Button>
          <Button type="button" variant="contained" onClick={handleDialogSubmit}>Adicionar</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default TagsEdit;
